import { object, string } from 'yup';
import { LoginFormType } from './types';
import i18n from '../../../i18n';

export const LoginFormSchema = object<LoginFormType>({
  email: string()
    .email(() => i18n.t('validation:email'))
    .required(() => i18n.t('validation:required')),
  password: string()
    .required(() => i18n.t('validation:required'))
    .matches(/^\S+$/, () => i18n.t('validation:password.whitespace')),
});
